exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-rearwall-dialog {\n  display: block;\n  max-width: 500px;\n}", ""]);

// exports
